export function getPhoneStyles() {
  return require('./styles.module.css');
}